import template from './player.html'

const computeScaleFactor = (measureWidth, measureHeight, widthIsFinite, heightIsFinite, nativeWidth, nativeHeight, imageStretch) => {
    let scaleW = 1;
    let scaleH = 1;
    if ((imageStretch === 'aspectFill' || imageStretch === 'aspectFit' || imageStretch === 'fill') && (widthIsFinite || heightIsFinite)) {
        scaleW = nativeWidth > 0 ? measureWidth / nativeWidth : 0;
        scaleH = nativeHeight > 0 ? measureHeight / nativeHeight : 0;
        if (!widthIsFinite) {
            scaleW = scaleH;
        }
        else if (!heightIsFinite) {
            scaleH = scaleW;
        }
        else {
            // No infinite dimensions.
            switch (imageStretch) {
                case 'aspectFit':
                    scaleH = scaleW < scaleH ? scaleW : scaleH;
                    scaleW = scaleH;
                    break;
                case 'aspectFill':
                    scaleH = scaleW > scaleH ? scaleW : scaleH;
                    scaleW = scaleH;
                    break;
            }
        }
    }
    return { width: scaleW, height: scaleH };
}

const playerComponent2 = (params) => {
    const player = new Player()
    console.log(player)
    return {
        id: params.id || 0,
        attrClass: params.attrClass || '',
        videoWidth: params.width || 100,
        videoHeight: params.height || 100,
        videoTop: 0,
        videoLeft: 0,
        parent: null,
        camera: params.camera,
        device: params.device,
        path: params.path,
        loading: false,
        playing: false,
        isPlayBack: false,
        playbackBody: null,
        playBody: null,
        events: {},
        async init() {
            this.parent = this
            
            //this.app.on('onPlayInfo', this.onPlayInfo, this)
            //this.app.on('onStop', this.onStop, this)
            this.$nextTick(() => {
                this.$el.innerHTML = template
                if(this.events.ready) this.events.ready()
            })
        },
        onPlayInfo(info) {
            if (info.id != this.id) return
            this.loading = false
            console.log('Page on native info!!!!!!!!!!!')
            console.log(info)
            this.root.callIOS('keepScreenAwake')
            this.updateVideoSize(info)
            if (!this.isPlayBack) this.root.callIOS('playerScreenshot', { id: this.id, path: this.path + '/preview-' + this.device.id + '-' + this.camera.channel + '.png' })
        },
        onStop(info) {
            if (info.id != this.id) return
            this.loading = false
            this.playing = false
        },
        async destroy() {
            console.log('Destroy player!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!')
            if (!this.isPlayBack) await this.root.callIOS('playerScreenshot', { id: this.id, path: this.path + '/preview-' + this.device.id + '-' + this.camera.channel + '.png' })
            await this.stop()

            this.app.off('onPlayInfo', this.onPlayInfo)
            
            await this.parent.callIOS('removePlayer', {id: this.id})
        },
        async play() {
            //await this.stop()
            this.loading = true
            this.playing = true
            this.isPlayBack = false
            setTimeout(_ => this._play(), 100)
        },
        async playback(params) {
            if (this.playing) await this.stop()
            this.loading = true
            setTimeout(() => this._playback(params), 100)
        },
        async _play() {
            try {
                const canvas = document.getElementById('playCanvas'+this.id)
                player.play('wss://api.cloud.videokot.ru/ws', canvas, function (e) {
                    console.log("play error " + e.error + " status " + e.status + ".");
                    if (e.error == 1) {
                        logger.logInfo("Finished.");
                    }
                }, 512 * 1024, true, 0);
            } catch (e) {
                console.log('finish err')
                console.log(e.message)
            }
        },
        async stop() {
            if (this.isPlayBack) {
                await this._stopplayback()
            } else {
                await this._stop()
            }
        },
        _stop() {
            this.loading = false
            this.playing = false
            this.isPlayBack = false

            return new Promise(resolve => {
                setTimeout(async _ => {
                    player.stop()
                    resolve()
                }, 100)
            })
        },
        async _stopplayback() {
            this.loading = false
            this.playbackBody.OPPlayBack.Action = 'Stop'
            await this.parent.callIOS('dvripCall', {
                id: this.id,
                code: 1420,
                body: this.playbackBody
            })
            this.playing = false
            this.isPlayBack = false

            await this.parent.callIOS('stopPlayer', { id: this.id }).catch((err, data) => {
                console.log(err)
            })
        },
        updateVideoSize(info) {
            const stretch = 'aspectFit'
            const width = this.app.orientation == 'portrait' ? window.screen.width : window.screen.height
            const height = this.app.orientation == 'portrait' ? window.screen.height : window.screen.width

            let finiteWidth = true
            let finiteHeight = false

            if (width > height) {
                finiteWidth = false
                finiteHeight = true
            }

            const scale = computeScaleFactor(width, height, finiteWidth, finiteHeight, info.width, info.height, stretch);
            const resultW = Math.round(info.width * scale.width);
            const resultH = Math.round(info.height * scale.height);
            const measureWidth = finiteWidth ? Math.min(resultW, width) : resultW;
            const measureHeight = finiteHeight ? Math.min(resultH, height) : resultH;

            /*if (this.app.orientation == 'portrait') {
                this.videoWidth = measureWidth
                this.videoHeight = measureHeight
            } else {
                this.videoWidth = width
                this.videoHeight = height
            }
            
            this.$nextTick(_ => {
                this.parent.callIOS('setPlayerParams', {
                    id: this.id,
                    params: [['width', this.videoWidth], ['height', this.videoHeight]]
                })
            })
            console.log('size')
            console.log(measureWidth)
            console.log(measureHeight)
            console.log(width)
            console.log(height)*/
        },
        async _playback(params) {
            console.log('!!!!!!!!!!!!! dvripPlayback')
            await this.parent.connectDvrip(this.id,{
                serverURI: this.device.serverURI,
                deviceID: this.device.id
            })
            try {
                let body = {
                    Name: 'OPPlayBack',
                    SessionID: '0x0',
                    OPPlayBack: {
                        Action: 'Claim',
                        StartTime: params.BeginTime,
                        EndTime: params.EndTime,
                        Parameter: {
                            PlayMode: 'ByTime',
                            Channel: params.stream,
                            StreamType: 0,
                            Value: 0,
                            FileName: '',
                            TransMode: 'TCP'
                        }
                    }
                }

                let resp = await this.parent.callIOS('dvripCallback', {
                    id: this.id,
                    code: 1424,
                    channel: params.stream,
                    body: body
                })

                let answ = JSON.parse(resp.substring(0, resp.length - 1))
                console.log(answ)

                body.OPPlayBack.Action = 'Start'
                this.playbackBody = body

                resp = await this.parent.callIOS('dvripCall', {
                    id: this.id,
                    code: 1420,
                    channel: params.stream,
                    body: body
                })
                this.playing = true
                this.isPlayBack = true

                await this.parent.callIOS('startStream', {
                    id: this.id,
                    filename: params.path,
                }).catch((err, data) => {
                    console.log(err)
                })

                await this.parent.callIOS('startPlayer', {
                    id: this.id,
                    filename: params.path,
                    formatOpts: params.formatOpts,
                    //formatOpts: null,
                    //codecOpts: device.codecOpts
                }).catch((err, data) => {
                    console.log(err)
                })
            } catch (e) {
                console.log('finish err')
                console.log(e.message)
            }
        },
        async playbackFiles(params) {
            await this.parent.connectDvrip(this.id, {
                serverURI: this.device.serverURI,
                deviceID: this.device.id
            })
            const resp = await this.parent.callIOS('dvripCallback', {
              id: this.id,
              code: 1440,
              body: {
                Name: 'OPFileQuery',
                SessionID: '0x0',
                OPFileQuery: {
                  BeginTime: params.BeginTime, 
                  EndTime: params.EndTime,
                  Channel: params.channel,
                  DriverTypeMask: '0x0000FFFF',
                  Event: '*',
                  Type: 'h265',
                }
              }
            })
            const json = JSON.parse(resp.substring(0, resp.length - 1))
            return json.OPFileQuery
        },
        on(name, cb) {
            this.events[name] = cb
        },
        nativeHide() {
            this.parent.callIOS('setPlayerParams', {
                id: this.id,
                params: [['visibility', 'collapsed']]
            })
        },
        nativeShow() {
            if (this.parent) this.parent.callIOS('setPlayerParams', {
                id: this.id,
                params: [['visibility', 'visible']]
            })
        },
        async setWidth(width) {
            this.videoWidth = width
            if (!this.parent) return
            await this.parent.callIOS('setPlayerParams', {
                id: this.id,
                params: [['width', width]]
            })
        },
        async setHeight(height) {
            this.videoHeight = height
            if (!this.parent) return
            await this.parent.callIOS('setPlayerParams', {
                id: this.id,
                params: [['height', height]]
            })
        },
        async setTop(top) {
            this.videoTop = top
            if (!this.parent) return
            await this.parent.callIOS('setPlayerParams', {
                id: this.id,
                params: [['top', top]]
            })
        },
        async setLeft(left) {
            this.videoLeft = left
            if (!this.parent) return
            await this.parent.callIOS('setPlayerParams', {
                id: this.id,
                params: [['left', left]]
            })
        }
    }
}

export { playerComponent2 }
